import type React from "react";

import type { GameMeta } from "@/app/game-definition.mjs";
import type { GameSymbol } from "@/app/games.mjs";
import gamesList from "@/app/games.mjs";
import type { GameArticlesEntry } from "@/marketing/GameArticles.jsx";
import type { ContentfulGameConfig } from "@/marketing/HomeGamePage.jsx";
import SymbolMap from "@/util/symbol-map.mjs";

export interface PageDefinition {
  meta: {
    title: Translation;
    description: Translation;
  };

  bg: string;
  bgVideo?: string;

  leaderboard?: () => React.JSX.Element;

  players?: string;

  matches?: string;

  guides: Array<() => React.JSX.Element>;

  pros: Array<{
    name: string;
    src: string | (() => Promise<{ default: string }>);

    region?: string;
    id?: string;
  }>;

  features: Array<{
    title: Translation;
    description: Translation;
    image: string;
  }>;

  articles: Array<GameArticlesEntry>;

  homepageFeatures?: Array<ContentfulGameConfig>;
}

export const PAGE_DEFINITION = new SymbolMap<
  PartialRecord<GameSymbol, PageDefinition>
>({
  // don't care about undefined here.
  // @ts-ignore
  ...gamesList.reduce((obj, { gameSymbol, meta }) => {
    const m = meta as GameMeta;
    obj[gameSymbol] = {
      meta: m?.game,
      pros: m?.pros ?? [],
      bg: m?.bg,
      bgVideo: m?.bgVideo,
      players: m?.players,
      matches: m?.matches,
      guides: m?.guides ?? [],
      features: m?.features ?? [],
      articles: m?.articles ?? [],
      leaderboard: m?.leaderboard,
    };
    return obj;
  }, {}),
  // FORBIDDEN TO ADD ENTRIES MANUALLY HERE
});
